import { Button, Icon } from 'antd';
import { createPortal } from 'react-dom';

import { FormFooter } from 'components/forms/FormFooter';
import { SKULL_CUSTOM_FOOTER_PORTAL_ROOT_ID, useSkullConfigContext } from 'components/skull';
import { tc, tCommon } from 'utils/i18nUtil';

export interface SDKCustomSynapseSharingFooterProps {
  onPrevious: (gotoPrevious: () => void) => void;
  onNext: (gotoNext: () => void) => void;
  loadingNext: boolean;
}

export const SDKCustomSynapseSharingFooter = ({
  onPrevious,
  onNext,
  loadingNext,
}: SDKCustomSynapseSharingFooterProps) => {
  const { currentStep, next, previous, steps } = useSkullConfigContext();

  const footerRootNode = document.getElementById(SKULL_CUSTOM_FOOTER_PORTAL_ROOT_ID);
  if (!footerRootNode) {
    return null;
  }

  const nextStepName = steps?.[currentStep + 1]?.stepName;
  const prevStepName = steps?.[currentStep - 1]?.stepName;

  return createPortal(
    <FormFooter
      left={
        <Button onClick={() => onPrevious(previous)}>
          <Icon type="arrow-left" /> {prevStepName ?? tCommon('previous')}
        </Button>
      }
      right={
        <Button type="primary" onClick={() => onNext(next)} loading={loadingNext}>
          {nextStepName ?? tc('next')} <Icon type="arrow-right" />
        </Button>
      }
    />,
    footerRootNode
  );
};
